import React, { useState, useEffect } from 'react';
import { Table, Button, Card, Typography, Tag, Space, Input, Modal, Form, Select, Row, Col, Divider, message, Switch, Tabs, Popconfirm, Upload } from 'antd';
import { PlusOutlined, SearchOutlined, EditOutlined, DeleteOutlined, StarFilled, StarOutlined, BankOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import { usePermissao } from '../hooks/usePermissao';
import axios from 'axios';

// A coluna art_validade e DATA no banco: volta como 2029-10-14T00:00:00 e o
// campo e um Input de texto, entao mostrava o timestamp cru. Converte nas duas
// pontas - exibe DD/MM/AAAA, grava AAAA-MM-DD - em vez de deixar o Postgres
// adivinhar a ordem dos numeros.
const artParaBR = (v) => {
  if (!v) return '';
  const m = String(v).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? m[3] + '/' + m[2] + '/' + m[1] : String(v);
};
const artParaISO = (v) => {
  if (!v) return null;
  const m = String(v).trim().match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  return m ? m[3] + '-' + m[2] + '-' + m[1] : (String(v).trim() || null);
};

const { Title, Text } = Typography;
const { Option } = Select;

const SETORES = ['Compras','Manutenção','Qualidade','Financeiro','Fiscal','Ambiente','Comercial','Administrativo','RH','Direção','Outro'];
const FORMAS_PAGAMENTO = ['À vista','Pix','Boleto','Cartão de crédito','10 dias','15 dias','30 dias','60 dias','90 dias','120 dias','30/60','30/60/90','10 dias fora mês de emissão da NF'];

function Clientes({ embutido = false, editarId = null, onFechar, onSalvo } = {}) {
  const { podeExcluir } = usePermissao();
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [filtroCidade, setFiltroCidade] = useState('');
  const [filtroNome, setFiltroNome] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [clienteEditando, setClienteEditando] = useState(null);
  const [tipo, setTipo] = useState('PJ');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('novo') === 'true') {
      setClienteEditando(null);
      setModalVisible(true);
    }
  }, [searchParams]);
  const [form] = Form.useForm();
  const [contatos, setContatos] = useState([]);
  const [enderecos, setEnderecos] = useState([]);
  const [cnpjs, setCnpjs] = useState([]);
  const [modalContato, setModalContato] = useState(false);
  const [modalEndereco, setModalEndereco] = useState(false);
  const [modalCnpj, setModalCnpj] = useState(false);
  const [socios, setSocios] = useState([]);
  const [contatoEditando, setContatoEditando] = useState(null);
  const [enderecoEditando, setEnderecoEditando] = useState(null);
  const [cnpjEditando, setCnpjEditando] = useState(null);
  const [enderecoIgualFiscal, setEnderecoIgualFiscal] = useState(false);
  const [formC] = Form.useForm();
  const [formE] = Form.useForm();
  const [formCnpj] = Form.useForm();
  const [dadosFiscais, setDadosFiscais] = useState({});

  useEffect(() => { if (!embutido) carregarClientes(); }, []);
  // embutido na pagina do cliente: abre direto a edicao daquele cliente
  useEffect(() => {
    if (!embutido || !editarId) return;
    api.get('/clientes/' + editarId).then((r) => { if (r.data) abrirModal(r.data); }).catch(() => message.error('Cliente nao encontrado'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [embutido, editarId]);
  const fecharModalCliente = () => {
    setModalVisible(false);
    if (embutido) { if (onFechar) onFechar(); return; }
    const ed = searchParams.get('editar'); if (ed) navigate('/clientes/' + ed);
  };
  // vindo da pagina do cliente (botao Editar cliente): abre o cadastro direto na edicao
  const editarAberto = React.useRef(null);
  useEffect(() => {
    const ed = searchParams.get('editar');
    if (!ed || editarAberto.current === ed) return;
    editarAberto.current = ed;
    api.get('/clientes/' + ed).then((r) => { if (r.data) abrirModal(r.data); }).catch(() => message.error('Cliente nao encontrado'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const carregarClientes = async () => {
    try { setLoading(true); const r = await api.get('/clientes'); setClientes(r.data); }
    catch { message.error('Erro ao carregar clientes'); }
    finally { setLoading(false); }
  };

  const consultarCNPJ = async (c) => {
    for (let i = 0; i < 2; i++) {
      try { return await api.get('/cnpj/' + c); } // o servidor tenta BrasilAPI, minhareceita e OpenCNPJ
      catch (e) {
        const st = e?.response?.status;
        if (i === 0 && (!st || st === 429 || st >= 500)) { await new Promise(ok => setTimeout(ok, 2500)); continue; }
        throw e;
      }
    }
  };

  const buscarCNPJ = async (cnpj) => {
    const c = cnpj.replace(/\D/g, '');
    if (c.length !== 14) return;
    try {
      const r = await consultarCNPJ(c);
      const d = r.data;
      // Complemento pelo ViaCEP quando a Receita/BrasilAPI vier sem logradouro
      if ((!d.logradouro || !String(d.logradouro).trim()) && d.cep && String(d.cep).replace(/\D/g, '').length === 8) {
        try {
          const v = await axios.get(`https://viacep.com.br/ws/${String(d.cep).replace(/\D/g, '')}/json/`);
          if (v.data && !v.data.erro) {
            d.logradouro = v.data.logradouro || '';
            if (!d.bairro) d.bairro = v.data.bairro || '';
            if (!d.municipio) d.municipio = v.data.localidade || '';
            if (!d.uf) d.uf = v.data.uf || '';
            if (!d.codigo_municipio_ibge) d.codigo_municipio_ibge = v.data.ibge || '';
            message.info('Logradouro completado pelo CEP — confira o número.');
          }
        } catch {}
      }
      const fiscal = { logradouro_fiscal: d.logradouro || '', numero_fiscal: d.numero || 'S/N', complemento_fiscal: d.complemento || '', bairro_fiscal: d.bairro || '', cidade_fiscal: d.municipio || '', estado_fiscal: d.uf || '', cep_fiscal: d.cep ? d.cep.replace(/\D/g, '') : '', codigo_municipio_ibge: d.codigo_municipio_ibge || '' };
      setDadosFiscais(fiscal);
      const regime = d.opcao_pelo_mei ? 'MEI' : d.opcao_pelo_simples ? 'Simples Nacional' : 'Lucro Presumido/Real';
      const situacao = d.descricao_situacao_cadastral || '';
      const dataAbertura = d.data_inicio_atividade ? d.data_inicio_atividade.substring(0,10) : '';
      form.setFieldsValue({ 
        razao_social: d.razao_social, 
        nome_fantasia: d.nome_fantasia || '',
        inscricao_estadual: '',
        situacao_cadastral: situacao,
        data_abertura: dataAbertura,
        regime_tributario: regime,
        capital_social: d.capital_social || 0,
        porte: d.porte || '',
        natureza_juridica: d.natureza_juridica || '',
        cnae_principal: String(d.cnae_fiscal || ''),
        cnae_descricao: d.cnae_fiscal_descricao || '',
        ...fiscal 
      });
      // Preencher socios automaticamente
      if (d.qsa && d.qsa.length > 0) {
        setSocios(d.qsa.map(s => ({
          nome: s.nome_socio || '',
          qualificacao: s.qualificacao_socio || '',
          data_entrada: s.data_entrada_sociedade || '',
          cpf_cnpj: s.cnpj_cpf_do_socio || '',
        })));
      }
      message.success('Dados preenchidos automaticamente!');
    } catch (e) { const st = e?.response?.status; console.error('Consulta CNPJ:', e); message.warning(st === 404 ? 'CNPJ não encontrado na Receita. Preencha manualmente.' : st === 429 ? 'Muitas consultas seguidas na Receita. Aguarde 1 minuto e tente de novo.' : 'Não foi possível consultar o CNPJ agora' + (st ? ' (erro ' + st + ')' : '') + '. Tente de novo ou preencha manualmente.'); }
  };

  const buscarCNPJFilial = async (cnpj) => {
    const c = cnpj.replace(/\D/g, '');
    if (c.length !== 14) return;
    try {
      const r = await consultarCNPJ(c);
      const d = r.data;
      // Complemento pelo ViaCEP quando a Receita/BrasilAPI vier sem logradouro
      if ((!d.logradouro || !String(d.logradouro).trim()) && d.cep && String(d.cep).replace(/\D/g, '').length === 8) {
        try {
          const v = await axios.get(`https://viacep.com.br/ws/${String(d.cep).replace(/\D/g, '')}/json/`);
          if (v.data && !v.data.erro) {
            d.logradouro = v.data.logradouro || '';
            if (!d.bairro) d.bairro = v.data.bairro || '';
            if (!d.municipio) d.municipio = v.data.localidade || '';
            if (!d.uf) d.uf = v.data.uf || '';
            if (!d.codigo_municipio_ibge) d.codigo_municipio_ibge = v.data.ibge || '';
            message.info('Logradouro completado pelo CEP — confira o número.');
          }
        } catch {}
      }
      const regime = d.opcao_pelo_mei ? 'MEI' : d.opcao_pelo_simples ? 'Simples Nacional' : 'Lucro Presumido/Real';
      formCnpj.setFieldsValue({
        razao_social: d.razao_social,
        nome_fantasia: d.nome_fantasia || '',
        inscricao_estadual: '',
        situacao_cadastral: d.descricao_situacao_cadastral || '',
        data_abertura: d.data_inicio_atividade ? d.data_inicio_atividade.substring(0,10) : '',
        regime_tributario: regime,
        capital_social: d.capital_social || 0,
        porte: d.porte || '',
        natureza_juridica: d.natureza_juridica || '',
        cnae_principal: String(d.cnae_fiscal || ''),
        cnae_descricao: d.cnae_fiscal_descricao || '',
        cep: d.cep ? d.cep.replace(/\D/g, '') : '',
        logradouro: d.logradouro || '', numero: d.numero || 'S/N',
        complemento: d.complemento || '', bairro: d.bairro || '',
        cidade: d.municipio || '', estado: d.uf || '',
        codigo_municipio_ibge: d.codigo_municipio_ibge || '',
      });
      message.success('Dados preenchidos automaticamente!');
    } catch (e) { const st = e?.response?.status; console.error('Consulta CNPJ:', e); message.warning(st === 404 ? 'CNPJ não encontrado na Receita. Preencha manualmente.' : st === 429 ? 'Muitas consultas seguidas na Receita. Aguarde 1 minuto e tente de novo.' : 'Não foi possível consultar o CNPJ agora' + (st ? ' (erro ' + st + ')' : '') + '. Tente de novo ou preencha manualmente.'); }
  };

  const buscarCEP = async (cep, formRef) => {
    const c = cep.replace(/\D/g, '');
    if (c.length !== 8) return;
    try {
      const r = await axios.get(`https://viacep.com.br/ws/${c}/json/`);
      if (!r.data.erro) { formRef.setFieldsValue({ logradouro: r.data.logradouro, bairro: r.data.bairro, cidade: r.data.localidade, estado: r.data.uf, codigo_ibge: r.data.ibge }); message.success('Endereço preenchido!'); }
    } catch { message.warning('CEP não encontrado.'); }
  };

  const toggleIgualFiscal = (checked) => {
    setEnderecoIgualFiscal(checked);
    if (checked) {
      let f = dadosFiscais || {};
      if (!f.logradouro_fiscal && !f.cep_fiscal) {
        const m = (cnpjs || []).find(c => c.matriz) || (cnpjs || [])[0];
        if (m) f = { logradouro_fiscal: m.logradouro, numero_fiscal: m.numero, complemento_fiscal: m.complemento, bairro_fiscal: m.bairro, cidade_fiscal: m.cidade, estado_fiscal: m.estado, cep_fiscal: m.cep, codigo_municipio_ibge: m.codigo_municipio_ibge };
      }
      if (!f.logradouro_fiscal && !f.cep_fiscal) message.warning('Nenhum endereço fiscal encontrado — cadastre o CNPJ na aba CNPJs/Filiais primeiro.');
      formE.setFieldsValue({ nome_local: 'Endereço Fiscal', cep: f.cep_fiscal || '', logradouro: f.logradouro_fiscal || '', numero: f.numero_fiscal || '', complemento: f.complemento_fiscal || '', bairro: f.bairro_fiscal || '', cidade: f.cidade_fiscal || '', estado: f.estado_fiscal || '', codigo_ibge: f.codigo_municipio_ibge || '' });
    } else { formE.resetFields(); }
  };

  const abrirModal = async (cliente = null) => {
    setClienteEditando(cliente);
    setContatos([]); setEnderecos([]); setCnpjs([]); setDadosFiscais({});
    if (cliente) {
      setTipo(cliente.tipo);
      form.setFieldsValue(cliente);
      setDadosFiscais({ logradouro_fiscal: cliente.logradouro_fiscal, numero_fiscal: cliente.numero_fiscal, complemento_fiscal: cliente.complemento_fiscal, bairro_fiscal: cliente.bairro_fiscal, cidade_fiscal: cliente.cidade_fiscal, estado_fiscal: cliente.estado_fiscal, cep_fiscal: cliente.cep_fiscal, codigo_municipio_ibge: cliente.codigo_municipio_ibge });
      try {
        const r = await api.get(`/clientes/${cliente.id}`);
        setContatos(r.data.contatos || []);
        setEnderecos(r.data.enderecos || []);
        const rCnpjs = await api.get(`/clientes/${cliente.id}/cnpjs`);
        setCnpjs(rCnpjs.data || []);
      } catch {}
    } else { setTipo('PJ'); form.resetFields(); form.setFieldsValue({ tipo: 'PJ' }); }
    if (cliente?.id) {
      api.get('/clientes/' + cliente.id + '/socios').then(r => setSocios(r.data || [])).catch(() => setSocios([]));
    } else {
      setSocios([]);
    }
    setModalVisible(true);
  };

  const [salvando, setSalvando] = useState(false);

  const salvarCliente = async (values) => {
    if (salvando) return;
    setSalvando(true);
    try {
      let clienteId;
      if (clienteEditando) {
        await api.put(`/clientes/${clienteEditando.id}`, values);
        await api.post(`/clientes/${clienteEditando.id}/socios`, { socios }).catch(() => {});
        clienteId = clienteEditando.id;
        message.success('Cliente atualizado!');
        // Recarregar dados após salvar
        const rCnpjs = await api.get(`/clientes/${clienteId}/cnpjs`);
        setCnpjs(rCnpjs.data || []);
        setModalVisible(false);
        if (embutido) { if (onSalvo) onSalvo(); } else navigate(`/clientes/${clienteId}`);
        return;
      } else {
        const r = await api.post('/clientes', values);
        clienteId = r.data.id;
        await api.post(`/clientes/${clienteId}/socios`, { socios }).catch(() => {});
        for (const c of contatos) await api.post(`/clientes/${clienteId}/contatos`, c);
        for (const e of enderecos) await api.post(`/clientes/${clienteId}/enderecos`, e);
        for (const cn of cnpjs) await api.post(`/clientes/${clienteId}/cnpjs`, cn);
        message.success('Cliente cadastrado!');
        setModalVisible(false);
        navigate(`/clientes/${clienteId}`);
        return;
      }
      setModalVisible(false);
      carregarClientes();
    } catch(e) { message.error(e.response?.data?.erro || 'Erro ao salvar cliente'); }
    finally { setSalvando(false); }
  };

  const recarregarCliente = async () => {
    if (!clienteEditando) return;
    const r = await api.get(`/clientes/${clienteEditando.id}`);
    setContatos(r.data.contatos || []);
    setEnderecos(r.data.enderecos || []);
    const rCnpjs = await api.get(`/clientes/${clienteEditando.id}/cnpjs`);
    setCnpjs(rCnpjs.data || []);
  };

  const salvarContatoDB = async (values) => {
    try {
      if (contatoEditando?.id) await api.put(`/clientes/${clienteEditando.id}/contatos/${contatoEditando.id}`, values);
      else await api.post(`/clientes/${clienteEditando.id}/contatos`, values);
      message.success('Contato salvo!');
      await recarregarCliente();
      setModalContato(false); formC.resetFields(); setContatoEditando(null);
    } catch { message.error('Erro ao salvar contato'); }
  };

  const salvarEnderecoDB = async (values) => {
    try {
      if (enderecoEditando?.id) await api.put(`/clientes/${clienteEditando.id}/enderecos/${enderecoEditando.id}`, values);
      else await api.post(`/clientes/${clienteEditando.id}/enderecos`, values);
      message.success('Endereço salvo!');
      await recarregarCliente();
      setModalEndereco(false); formE.resetFields(); setEnderecoEditando(null); setEnderecoIgualFiscal(false);
    } catch { message.error('Erro ao salvar endereço'); }
  };

  const salvarCnpjDB = async (values) => {
    try {
      if (cnpjEditando?.id) await api.put(`/clientes/${clienteEditando.id}/cnpjs/${cnpjEditando.id}`, values);
      else await api.post(`/clientes/${clienteEditando.id}/cnpjs`, values);
      message.success('CNPJ salvo!');
      await recarregarCliente();
      setModalCnpj(false); formCnpj.resetFields(); setCnpjEditando(null);
    } catch { message.error('Erro ao salvar CNPJ'); }
  };

  const adicionarNaLista = (tipo, values) => {
    if (tipo === 'contato') { setContatos([...contatos, values]); setModalContato(false); formC.resetFields(); }
    if (tipo === 'endereco') { setEnderecos([...enderecos, values]); setModalEndereco(false); formE.resetFields(); setEnderecoIgualFiscal(false); }
    if (tipo === 'cnpj') {
      setCnpjs([...cnpjs, values]);
      // Adicionar endereço automaticamente se tiver logradouro
      if (values.logradouro && values.cidade) {
        setEnderecos(prev => [...prev, {
          nome_local: values.razao_social || values.cnpj,
          logradouro: values.logradouro,
          numero: values.numero,
          complemento: values.complemento,
          bairro: values.bairro,
          cidade: values.cidade,
          estado: values.estado,
          cep: values.cep,
        }]);
      }
      setModalCnpj(false); formCnpj.resetFields();
    }
  };

  const handleContatoFinish = (v) => clienteEditando?.id ? salvarContatoDB(v) : adicionarNaLista('contato', v);
  const handleEnderecoFinish = (v) => clienteEditando?.id ? salvarEnderecoDB(v) : adicionarNaLista('endereco', v);
  const handleCnpjFinish = (v) => {
    const d = { ...v, art_validade: artParaISO(v.art_validade) };
    return clienteEditando?.id ? salvarCnpjDB(d) : adicionarNaLista('cnpj', d);
  };

  const removerItem = async (tipo, idx, id) => {
    if (id && clienteEditando?.id) {
      if (tipo === 'contato') await api.delete(`/clientes/${clienteEditando.id}/contatos/${id}`);
      if (tipo === 'endereco') await api.delete(`/clientes/${clienteEditando.id}/enderecos/${id}`);
      if (tipo === 'cnpj') await api.delete(`/clientes/${clienteEditando.id}/cnpjs/${id}`);
      await recarregarCliente();
    } else {
      if (tipo === 'contato') setContatos(contatos.filter((_, i) => i !== idx));
      if (tipo === 'endereco') setEnderecos(enderecos.filter((_, i) => i !== idx));
      if (tipo === 'cnpj') setCnpjs(cnpjs.filter((_, i) => i !== idx));
    }
  };

  const cidades = [...new Set(clientes.map(c => c.cidade_cnpj || c.cidade_fiscal).filter(Boolean))].sort();

  const clientesFiltrados = clientes
    .filter(c =>
      ((c.razao_social || c.nome || '').toLowerCase().includes(busca.toLowerCase()) ||
      (c.codigo || '').includes(busca) ||
      (c.cnpj || '').replace(/\D/g,'').includes(busca.replace(/\D/g,''))) &&
      (!filtroCidade || (c.cidade_cnpj || c.cidade_fiscal) === filtroCidade) &&
      (!filtroNome || c.id === filtroNome)
    )
    .sort((a, b) => (a.razao_social || a.nome || '').localeCompare(b.razao_social || b.nome || '', 'pt-BR'));

  const colunas = [
    { title: 'Ações', width: 120, render: (_, r) => (
      <Space size={4}>
        <Button icon={<EyeOutlined />} size="small" onClick={() => navigate(`/clientes/${r.id}`)} />
        <Button icon={<EditOutlined />} size="small" type="primary" onClick={() => abrirModal(r)} />
        {podeExcluir && <Popconfirm title="Excluir cliente?" onConfirm={async () => { await api.delete('/clientes/' + r.id); carregarClientes(); message.success('Cliente removido!'); }}><Button icon={<DeleteOutlined />} size="small" danger /></Popconfirm>}
      </Space>
    )},
    { title: 'Código', dataIndex: 'codigo', width: 100, render: (v) => <Tag color="blue">{v}</Tag> },
    { title: 'Nome / Razão Social', dataIndex: 'razao_social', render: (v, r) => v || r.nome },
    { title: 'CNPJ', dataIndex: 'cnpj', width: 160 },
    { title: 'Tipo', dataIndex: 'tipo', width: 60, render: (v) => <Tag color={v === 'PJ' ? 'blue' : 'green'}>{v}</Tag> },
    { title: 'Cidade', render: (_, r) => r.cidade_cnpj || r.cidade_fiscal || '-' },
  ];

  return (
    <div>
      {!embutido && (<>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <Title level={4} style={{ margin: 0 }}>Clientes</Title>
        <Button type="primary" icon={<PlusOutlined />} size="large" onClick={() => abrirModal()}>Novo Cliente</Button>
      </div>
      <Card>
        <Space style={{ marginBottom: 16 }} wrap>
          <Input placeholder="Buscar por código ou CNPJ..." prefix={<SearchOutlined />} style={{ width: 250 }} value={busca} onChange={(e) => setBusca(e.target.value)} />
          <Select placeholder="Filtrar por nome..." style={{ width: 300 }} allowClear showSearch optionFilterProp="children" onChange={v => setFiltroNome(v || null)}>
            {clientes.sort((a,b) => (a.razao_social||a.nome||'').localeCompare(b.razao_social||b.nome||'')).map(c => <Option key={c.id} value={c.id}>{c.razao_social || c.nome}</Option>)}
          </Select>
          <Select placeholder="Filtrar por cidade" style={{ width: 200 }} allowClear onChange={v => setFiltroCidade(v || '')}>
            {cidades.map(cidade => <Option key={cidade} value={cidade}>{cidade}</Option>)}
          </Select>
        </Space>
        <Table columns={colunas} dataSource={clientesFiltrados} loading={loading} locale={{ emptyText: 'Nenhum cliente cadastrado ainda.' }} rowKey="id" />
      </Card>
      </>)}

      <Modal title={clienteEditando ? `Editar Cliente — ${clienteEditando.codigo}` : 'Novo Cliente'} open={modalVisible} onCancel={fecharModalCliente} footer={
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={fecharModalCliente}>Fechar</Button>
            <Button type="primary" onClick={() => form.submit()} loading={salvando}>Salvar Cliente</Button>
          </div>
        } width={920} style={{ top: 20 }}>
        <Tabs defaultActiveKey="dados">
          <Tabs.TabPane tab="Dados Cadastrais" key="dados">
            <Form form={form} layout="vertical" onFinish={salvarCliente}>
              <Form.Item name="tipo" label="Tipo de Cliente" rules={[{ required: true }]}>
                <Select onChange={setTipo}><Option value="PJ">Pessoa Jurídica (PJ)</Option><Option value="PF">Pessoa Física (PF)</Option></Select>
              </Form.Item>
              {tipo === 'PJ' ? (<>
                <Row gutter={16}>
                  <Col span={12}><Form.Item name="cnpj" label="CNPJ Principal" rules={[{ required: true }]}><Input placeholder="00.000.000/0000-00" onBlur={(e) => buscarCNPJ(e.target.value)} /></Form.Item></Col>
                  <Col span={12}><Form.Item name="razao_social" label="Razão Social / Nome do Grupo" rules={[{ required: true }]}><Input /></Form.Item></Col>
                </Row>
                <Row gutter={16}>
                  <Col span={12}><Form.Item name="inscricao_estadual" label="Inscrição Estadual"><Input /></Form.Item></Col>
                  <Col span={12}><Form.Item name="inscricao_municipal" label="Inscrição Municipal"><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="situacao_cadastral" label="Situação Cadastral"><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="data_abertura" label="Data de Abertura"><Input placeholder="AAAA-MM-DD" /></Form.Item></Col>
                  <Col span={8}><Form.Item name="regime_tributario" label="Regime Tributário"><Select allowClear><Select.Option value="MEI">MEI</Select.Option><Select.Option value="Simples Nacional">Simples Nacional</Select.Option><Select.Option value="Lucro Presumido/Real">Lucro Presumido/Real</Select.Option></Select></Form.Item></Col>
                  <Col span={8}><Form.Item name="porte" label="Porte"><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="natureza_juridica" label="Natureza Jurídica"><Input /></Form.Item></Col>
                  <Col span={8}><Form.Item name="capital_social" label="Capital Social (R$)"><Input /></Form.Item></Col>
                  <Col span={12}><Form.Item name="cnae_principal" label="CNAE Principal"><Input /></Form.Item></Col>
                  <Col span={12}><Form.Item name="cnae_descricao" label="Descrição CNAE"><Input /></Form.Item></Col>
                </Row>
              </>) : (
                <Row gutter={16}>
                  <Col span={12}><Form.Item name="cpf" label="CPF" rules={[{ required: true }]}><Input placeholder="000.000.000-00" /></Form.Item></Col>
                  <Col span={12}><Form.Item name="nome" label="Nome Completo" rules={[{ required: true }]}><Input /></Form.Item></Col>
                </Row>
              )}

              <Form.Item name="forma_pagamento" label="Forma de Pagamento Padrão">
                <Select>{FORMAS_PAGAMENTO.map(f => <Option key={f} value={f}>{f}</Option>)}</Select>
              </Form.Item>

            </Form>
          </Tabs.TabPane>

          <Tabs.TabPane tab={`Sócios (${socios.length})`} key="socios">
            <div style={{ marginBottom: 8 }}>
              <Button type="dashed" icon={<PlusOutlined />} onClick={() => setSocios([...socios, { nome: '', qualificacao: '', data_entrada: '', cpf_cnpj: '' }])}>Adicionar Sócio</Button>
            </div>
            {socios.map((s, idx) => (
              <Card key={idx} size="small" style={{ marginBottom: 8 }} extra={
                <Button danger size="small" onClick={() => setSocios(socios.filter((_, i) => i !== idx))}>Remover</Button>
              }>
                <Row gutter={12}>
                  <Col span={8}><Input placeholder="Nome" value={s.nome} onChange={e => { const ns=[...socios]; ns[idx].nome=e.target.value; setSocios(ns); }} /></Col>
                  <Col span={8}><Input placeholder="Qualificação (ex: Sócio-Administrador)" value={s.qualificacao} onChange={e => { const ns=[...socios]; ns[idx].qualificacao=e.target.value; setSocios(ns); }} /></Col>
                  <Col span={4}><Input placeholder="Data Entrada (AAAA-MM-DD)" value={s.data_entrada} onChange={e => { const ns=[...socios]; ns[idx].data_entrada=e.target.value; setSocios(ns); }} /></Col>
                  <Col span={4}><Input placeholder="CPF/CNPJ" value={s.cpf_cnpj} onChange={e => { const ns=[...socios]; ns[idx].cpf_cnpj=e.target.value; setSocios(ns); }} /></Col>
                </Row>
              </Card>
            ))}
          </Tabs.TabPane>
          <Tabs.TabPane tab={<span><BankOutlined /> CNPJs/Filiais ({cnpjs.length})</span>} key="cnpjs">
            <div style={{ marginBottom: 8, padding: '8px 12px', background: '#e6f7ff', borderRadius: 8 }}>
              <Text type="secondary">Cadastre aqui todas as filiais e CNPJs do grupo. Na proposta você seleciona qual CNPJ será faturado.</Text>
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => { setCnpjEditando(null); formCnpj.resetFields(); setModalCnpj(true); }}>Novo CNPJ/Filial</Button>
            </div>
            {cnpjs.map((cn, idx) => (
              <Card key={idx} size="small" style={{ marginBottom: 8 }} extra={
                <Space>
                  {cn.matriz && <Tag color="gold"><StarFilled /> Matriz</Tag>}
                  <Button icon={<EditOutlined />} size="small" onClick={() => { setCnpjEditando(cn); formCnpj.setFieldsValue({ ...cn, art_validade: artParaBR(cn.art_validade) }); setModalCnpj(true); }}>Editar</Button>
                  {cn.art_numero && (
                    <Upload
                      accept=".pdf"
                      showUploadList={false}
                      beforeUpload={async (file) => {
                        const fd = new FormData();
                        fd.append('art', file);
                        try {
                          await api.post('/clientes/' + clienteEditando.id + '/cnpjs/' + cn.id + '/art', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
                          message.success('ART enviada!');
                        } catch { message.error('Erro ao enviar ART'); }
                        return false;
                      }}
                    >
                      <Button size="small" icon={<PlusOutlined />}>Upload ART</Button>
                    </Upload>
                  )}
                  {cn.art_caminho && (
                    <Button size="small" onClick={async () => {
                      try {
                        const r = await api.get('/clientes/' + clienteEditando.id + '/cnpjs/' + cn.id + '/art', { responseType: 'blob' });
                        const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
                        window.open(url, '_blank');
                      } catch { message.error('Erro ao abrir ART'); }
                    }}>Ver ART</Button>
                  )}
                  <Popconfirm title="Remover?" onConfirm={() => removerItem('cnpj', idx, cn.id)}><Button icon={<DeleteOutlined />} size="small" danger>Remover</Button></Popconfirm>
                </Space>
              }>
                <Row gutter={16}>
                  <Col span={8}><Text strong>{cn.cnpj}</Text></Col>
                  <Col span={16}><Text>{cn.razao_social}</Text></Col>
                </Row>
                {cn.cidade && <Row><Col><Text type="secondary">{cn.logradouro}, {cn.numero}, {cn.cidade} - {cn.estado}</Text></Col></Row>}
              </Card>
            ))}
            {cnpjs.length === 0 && <Text type="secondary">Nenhum CNPJ/filial cadastrado.</Text>}
          </Tabs.TabPane>

          <Tabs.TabPane tab={`Contatos (${contatos.length})`} key="contatos">
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => { setContatoEditando(null); formC.resetFields(); setModalContato(true); }}>Novo Contato</Button>
            </div>
            {contatos.map((c, idx) => (
              <Card key={idx} size="small" style={{ marginBottom: 8 }} extra={
                <Space>
                  {c.principal && <Tag color="gold"><StarFilled /> Principal</Tag>}
                  <Button icon={<EditOutlined />} size="small" onClick={() => { setContatoEditando(c); formC.setFieldsValue(c); setModalContato(true); }}>Editar</Button>
                  <Popconfirm title="Remover?" onConfirm={() => removerItem('contato', idx, c.id)}><Button icon={<DeleteOutlined />} size="small" danger>Remover</Button></Popconfirm>
                </Space>
              }>
                <Row gutter={16}>
                  <Col span={8}><Text strong>{c.nome}</Text> {c.setor && <Tag>{c.setor}</Tag>}</Col>
                  <Col span={8}><Text>{c.telefone}{c.telefone_secundario ? ' | ' + c.telefone_secundario : ''}</Text></Col>
                  <Col span={8}><Text>{c.email}</Text></Col>
                </Row>
                {c.observacao && <Text type="secondary">{c.observacao}</Text>}
              </Card>
            ))}
            {contatos.length === 0 && <Text type="secondary">Nenhum contato adicionado.</Text>}
          </Tabs.TabPane>

          <Tabs.TabPane tab={`Endereços (${enderecos.length})`} key="enderecos">
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
              <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEnderecoEditando(null); formE.resetFields(); setEnderecoIgualFiscal(false); setModalEndereco(true); }}>Novo Endereço</Button>
            </div>
            {enderecos.map((e, idx) => (
              <Card key={idx} size="small" style={{ marginBottom: 8 }} extra={
                <Space>
                  {e.principal && <Tag color="gold"><StarFilled /> Principal</Tag>}
                  <Button icon={<EditOutlined />} size="small" onClick={() => { setEnderecoEditando(e); formE.setFieldsValue(e); setModalEndereco(true); }}>Editar</Button>
                  <Popconfirm title="Remover?" onConfirm={() => removerItem('endereco', idx, e.id)}><Button icon={<DeleteOutlined />} size="small" danger>Remover</Button></Popconfirm>
                </Space>
              }>
                <Text strong>{e.nome_local}</Text><br />
                <Text>{e.logradouro}, {e.numero}{e.complemento ? ', ' + e.complemento : ''}, {e.bairro}, {e.cidade} - {e.estado}{e.cep ? ', CEP: ' + e.cep : ''}</Text>
                {e.referencia && <><br /><Text type="secondary">Ref: {e.referencia}</Text></>}
              </Card>
            ))}
            {enderecos.length === 0 && <Text type="secondary">Nenhum endereço adicionado.</Text>}
          </Tabs.TabPane>
        </Tabs>
      </Modal>

      <Modal title={cnpjEditando ? 'Editar CNPJ/Filial' : 'Novo CNPJ/Filial'} open={modalCnpj} onCancel={() => setModalCnpj(false)} footer={null} width={600}>
        <Form form={formCnpj} layout="vertical" onFinish={handleCnpjFinish}>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="cnpj" label="CNPJ" rules={[{ required: true }]}><Input placeholder="00.000.000/0000-00" onBlur={(e) => buscarCNPJFilial(e.target.value)} /></Form.Item></Col>
            <Col span={12}><Form.Item name="razao_social" label="Razão Social" rules={[{ required: true }]}><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="inscricao_estadual" label="Inscrição Estadual"><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="inscricao_municipal" label="Inscrição Municipal"><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="tipo_ie" label="Tipo IE"><Select allowClear><Select.Option value="contribuinte">Contribuinte</Select.Option><Select.Option value="isento">Isento</Select.Option><Select.Option value="nao_contribuinte">Não Contribuinte</Select.Option></Select></Form.Item></Col>
            <Col span={12}><Form.Item name="situacao_ie" label="Situação IE"><Select allowClear><Select.Option value="ativa">Ativa</Select.Option><Select.Option value="inativa">Inativa</Select.Option><Select.Option value="isento">Isento</Select.Option></Select></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="situacao_cadastral" label="Situação Cadastral"><Input /></Form.Item></Col>
            <Col span={8}><Form.Item name="data_abertura" label="Data de Abertura"><Input placeholder="AAAA-MM-DD" /></Form.Item></Col>
            <Col span={8}><Form.Item name="regime_tributario" label="Regime Tributário"><Select allowClear><Select.Option value="MEI">MEI</Select.Option><Select.Option value="Simples Nacional">Simples Nacional</Select.Option><Select.Option value="Lucro Presumido/Real">Lucro Presumido/Real</Select.Option></Select></Form.Item></Col>
            <Col span={12}><Form.Item name="cnae_principal" label="CNAE Principal"><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="cnae_descricao" label="Descrição CNAE"><Input /></Form.Item></Col>
          </Row>
          <Divider>ART</Divider>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="art_numero" label="Número da ART"><Input /></Form.Item></Col>
            <Col span={8}><Form.Item name="art_validade" label="Validade da ART"><Input placeholder="DD/MM/AAAA" /></Form.Item></Col>
            <Col span={8}>
              <Form.Item label="ART">
                <Space direction="vertical" style={{ width: '100%' }}>
                  {cnpjEditando?.art_caminho && (
                    <Button size="small" type="link" onClick={async () => {
                      try {
                        const r = await api.get('/clientes/' + clienteEditando.id + '/cnpjs/' + cnpjEditando.id + '/art', { responseType: 'blob' });
                        const url = URL.createObjectURL(r.data);
                        window.open(url, '_blank');
                      } catch { message.error('Erro ao abrir ART'); }
                    }}>📄 Ver ART salva</Button>
                  )}
                  <Upload beforeUpload={(file) => {
                    const fd = new FormData();
                    fd.append('art', file);
                    if (cnpjEditando?.id) {
                      api.post('/clientes/' + clienteEditando.id + '/cnpjs/' + cnpjEditando.id + '/art', fd, { headers: { 'Content-Type': 'multipart/form-data' } })
                        .then(() => message.success('ART enviada!'))
                        .catch(() => message.error('Erro ao enviar ART'));
                    } else {
                      message.warning('Salve o cadastro primeiro para enviar a ART');
                    }
                    return false;
                  }} showUploadList={false} accept=".pdf,.jpg,.png">
                    <Button icon={<UploadOutlined />}>{cnpjEditando?.art_caminho ? 'Substituir ART' : 'Upload ART'}</Button>
                  </Upload>
                </Space>
              </Form.Item>
            </Col>
          </Row>
          <Divider>Endereço</Divider>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="cep" label="CEP"><Input placeholder="00000-000" onBlur={(e) => buscarCEP(e.target.value, formCnpj)} /></Form.Item></Col>
            <Col span={16}><Form.Item name="logradouro" label="Logradouro"><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={6}><Form.Item name="numero" label="Número"><Input /></Form.Item></Col>
            <Col span={10}><Form.Item name="complemento" label="Complemento"><Input /></Form.Item></Col>
            <Col span={8}><Form.Item name="bairro" label="Bairro"><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}><Form.Item name="cidade" label="Cidade"><Input /></Form.Item></Col>
            <Col span={10}><Form.Item name="estado" label="Estado"><Input maxLength={2} /></Form.Item></Col>
            <Col span={12}><Form.Item name="codigo_municipio_ibge" label="Cód. IBGE Município"><Input placeholder="Ex: 3154606" /></Form.Item></Col>
          </Row>
          <Form.Item name="matriz" label="É a matriz?" valuePropName="checked">
            <Switch checkedChildren={<StarFilled />} unCheckedChildren={<StarOutlined />} />
          </Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={() => setModalCnpj(false)}>Cancelar</Button>
            <Button type="primary" htmlType="submit">Salvar</Button>
          </div>
        </Form>
      </Modal>

      <Modal title={contatoEditando ? 'Editar Contato' : 'Novo Contato'} open={modalContato} onCancel={() => setModalContato(false)} footer={null} width={600}>
        <Form form={formC} layout="vertical" onFinish={handleContatoFinish}>
          <Row gutter={16}>
            <Col span={14}><Form.Item name="nome" label="Nome" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={10}><Form.Item name="setor" label="Setor"><Select>{SETORES.map(s => <Option key={s} value={s}>{s}</Option>)}</Select></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}><Form.Item name="telefone" label="Telefone"><Input /></Form.Item></Col>
            <Col span={12}><Form.Item name="telefone_secundario" label="Telefone Secundário"><Input /></Form.Item></Col>
          </Row>
          <Form.Item name="email" label="E-mail"><Input /></Form.Item>
          <Form.Item name="observacao" label="Observação"><Input.TextArea rows={2} /></Form.Item>
          <Form.Item name="principal" label="Contato principal?" valuePropName="checked"><Switch checkedChildren={<StarFilled />} unCheckedChildren={<StarOutlined />} /></Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={() => setModalContato(false)}>Cancelar</Button>
            <Button type="primary" htmlType="submit">Salvar Contato</Button>
          </div>
        </Form>
      </Modal>

      <Modal title={enderecoEditando ? 'Editar Endereço' : 'Novo Endereço'} open={modalEndereco} onCancel={() => setModalEndereco(false)} footer={null} width={600}>
        <Form form={formE} layout="vertical" onFinish={handleEnderecoFinish}>
          <Form.Item name="nome_local" label="Nome do Local" rules={[{ required: true }]} extra="Ex: Sede, Filial Contagem, BR-040 km 320"><Input placeholder="Ex: Sede BH, Filial..." /></Form.Item>
          <div style={{ marginBottom: 16, padding: '8px 12px', background: '#f0f2f5', borderRadius: 8 }}>
            <Space><Switch onChange={toggleIgualFiscal} checked={enderecoIgualFiscal} /><Text>Mesmo endereço fiscal</Text></Space>
          </div>
          <Row gutter={16}>
            <Col span={8}><Form.Item name="cep" label="CEP"><Input placeholder="00000-000" onBlur={(e) => buscarCEP(e.target.value, formE)} /></Form.Item></Col>
            <Col span={16}><Form.Item name="logradouro" label="Logradouro" rules={[{ required: true }]}><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={6}><Form.Item name="numero" label="Número" rules={[{ required: true }]}><Input placeholder="123 ou S/N" /></Form.Item></Col>
            <Col span={10}><Form.Item name="complemento" label="Complemento"><Input placeholder="Apto, Sala..." /></Form.Item></Col>
            <Col span={8}><Form.Item name="bairro" label="Bairro"><Input /></Form.Item></Col>
          </Row>
          <Row gutter={16}>
            <Col span={14}><Form.Item name="cidade" label="Cidade" rules={[{ required: true }]}><Input /></Form.Item></Col>
            <Col span={10}><Form.Item name="estado" label="Estado" rules={[{ required: true }]}><Input maxLength={2} placeholder="MG" /></Form.Item></Col>
            <Col span={12}><Form.Item name="codigo_ibge" label="Cód. IBGE Município"><Input placeholder="Preenchido automaticamente pelo CEP" disabled /></Form.Item></Col>
          </Row>
          <Form.Item name="referencia" label="Ponto de Referência"><Input.TextArea rows={2} placeholder="Ex: Próximo ao portão principal..." /></Form.Item>
          <Form.Item name="principal" label="Endereço principal?" valuePropName="checked"><Switch checkedChildren={<StarFilled />} unCheckedChildren={<StarOutlined />} /></Form.Item>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={() => setModalEndereco(false)}>Cancelar</Button>
            <Button type="primary" htmlType="submit">Salvar Endereço</Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
}

export default Clientes;
